import { StateCreator } from 'zustand';

import { ListTemplatesQuery } from '../API';
import { api } from '../services';

type TemplatesStore = {
  templates: ListTemplatesQuery;
  fetchTemplates: () => Promise<void>;
  resetTemplates: () => void;
};

const initialState: ListTemplatesQuery = { listTemplates: null };

export const createTemplateState: StateCreator<TemplatesStore> = (set, get) => ({
  templates: initialState,
  resetTemplates: () => {
    set({ templates: initialState });
  },
  fetchTemplates: async () => {
    const templatesState = get().templates;
    const templatesResponse = await api.getTemplates({ nextToken: templatesState.listTemplates?.nextToken });
    if (templatesResponse && templatesResponse.items)
      set({
        templates: {
          listTemplates: {
            __typename: templatesResponse.__typename,
            items: [...(templatesState.listTemplates?.items || []), ...templatesResponse.items],
            nextToken: templatesResponse.nextToken,
          },
        },
      });
  },
});
